// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/helpIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Help" aria-label="Help" />;
}
